module.exports = __webpack_public_path__ + "img/xmasParty11.3eb09a56.jpg";